<template>
  <click-to-edit
    v-model="scope.row.model.card_weight"
    digits-only
    placeholder=""
    @input="scope.row.save()"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: 'cascading-element-weight-table-column',
  components: { ClickToEdit },
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
